module.exports = __webpack_public_path__ + "static/img/6.99c6a51.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/q_and_a/6.png
// module id = j5/7
// module chunks = 0